import { useDispatch, useSelector } from "react-redux";
import {
  getHistoricalAttendance,
  getHistoricalMarks,
  resetAttendance,
  resetMarks,
  resetState,
} from "../store/historical";

export default function useHistorical() {
  const dispatch = useDispatch();

  const attendanceData = useSelector(
    (state) => state.historical?.attendance?.data
  );
  const attendancePagination = useSelector(
    (state) => state.historical?.attendance?.totalNo
  );
  const marksData = useSelector((state) => state.historical?.marks);

  const loading = useSelector((state) => state.historical?.loading);

  const getHistoricalMarksAction = (params) =>
    dispatch(getHistoricalMarks(params));

  const getHistoricalAttendanceAction = (params) => {
    dispatch(getHistoricalAttendance(params));
  };

  const resetAttendanceAction = () => dispatch(resetAttendance());
  const resetStateAction = () => dispatch(resetState());
  const resetMarksAction = () => dispatch(resetMarks());

  return {
    attendanceData,
    marksData,
    attendancePagination,
    loading,

    getHistoricalMarksAction,
    getHistoricalAttendanceAction,
    resetMarksAction,
    resetStateAction,
    resetAttendanceAction,
  };
}
